import { CustomTabPanel } from "@/erp/sale";
import { a11yProps, EstadosPreagendamientoEnumChoice, useTabsFormOnly } from "@/shared";
import { SingleTableBoxScene, SingleBoxTableTabsOnly, FormTabsOnly } from "@/shared/components/ui";
import { Tab } from "@mui/material";
import TablePreAgendamientoSoportePymes from "../../shared/componente/table_agendamiento_pymes/TablePreAgendamientoSoportePymes";

export default function PreagendamientoSoportePymesPage() {

  const { handleMethodChange, valueTab } = useTabsFormOnly({});

  return (
    <SingleTableBoxScene title={"Agendamientos Soporte Pymes"}>
      <SingleBoxTableTabsOnly>
        <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
          <Tab label="Preagendamientos" value={1} {...a11yProps(1)} />
          <Tab label="Agendadas" value={2} {...a11yProps(2)} />
          <Tab label="Recoordinadas" value={3} {...a11yProps(3)} />
          <Tab label="Pendiente Técnico" value={4} {...a11yProps(3)} />
        </FormTabsOnly>
      </SingleBoxTableTabsOnly>

      {/* ============ Preagendamientos ============ */}
      <CustomTabPanel value={valueTab} index={1}>
        <TablePreAgendamientoSoportePymes
          estado_aceptacion={true}
          estado_preagendamiento={`${EstadosPreagendamientoEnumChoice.EN_ESPERA},${EstadosPreagendamientoEnumChoice.EN_PAUSA}`}
        />
      </CustomTabPanel>

      <CustomTabPanel value={valueTab} index={2}>
        {/* <TableAgendamientoSoportePymes /> */}
        <TablePreAgendamientoSoportePymes
          estado_aceptacion={true}
          estado_preagendamiento={EstadosPreagendamientoEnumChoice.FINALIZADO}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={3}>
        {/* <TableAgendamientoSoportePymes
          stateAgendamiento={EstadosAgendamientoEnumChoice.RECORDINADO}
        /> */}
        <TablePreAgendamientoSoportePymes
          estado_aceptacion={true}
          estado_preagendamiento={EstadosPreagendamientoEnumChoice.RECORDINADO}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={4}>
        {/* <SubTabPendienteTecnico /> */}
        <TablePreAgendamientoSoportePymes
          estado_aceptacion={true}
          solicitar_tecnico={true}
          enable_action={false}
        //estado_preagendamiento={EstadosAgendamientoEnumChoice.PENDIENTE_TECNICO}
        />
      </CustomTabPanel>

    </SingleTableBoxScene>
  );

}